import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { APIResponse } from 'fakturnia-shared';
import { take } from 'rxjs';
import { ApiService } from 'shared/services/api.service';
import { BankAccountsApiService } from 'shared/services/api/bank-accounts.api.service';
import { DialogService } from 'shared/services/dialog.service';
import { SettingsService } from 'shared/services/settings.service';
import { SnackbarService } from 'shared/services/snackbar.service';
import { Utils } from 'fakturnia-shared';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BankAccountFormatDirective } from 'shared/directives/bank-accont-format.directive';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatDialogModule, MatSelectModule, MatCheckboxModule, BankAccountFormatDirective],
  selector: 'app-add-or-update-bank-account-dialog',
  templateUrl: './add-or-update-bank-account-dialog.component.html',
  styleUrls: ['./add-or-update-bank-account-dialog.component.scss']
})
export class AddOrUpdateBankAccountDialogComponent {

  mode: 'create' | 'update' = 'create'
  showKsefFields = false

  // Opcje typu rachunku własnego banku (KSeF: RachunekWlasnyBanku) - dotyczy tylko banków/SKOK
  bankOwnAccountTypes = [
    { value: null, label: 'Nie dotyczy' },
    { value: 1, label: '1 - Rachunek własny banku Rachunek banku lub rachunek spółdzielczej kasy oszczędnościowo-kredytowej służący do dokonywania rozliczeń z tytułu nabywanych przez ten bank lub tę kasę wierzytelności pieniężnych' },
    { value: 2, label: '2 - Rachunek do pobrania należności' },
    { value: 3, label: '3 - Rachunek gospodarki własnej' }
  ]

  form = new FormGroup({
    _id: new FormControl(null),
    bank: new FormControl('',[Validators.required]),
    accountNumber: new FormControl('',[Validators.required]),
    isVATAccount: new FormControl(false),
    // Dodatkowe pola opcjonalne dla KSeF
    swift: new FormControl(''),
    accountDescription: new FormControl(''),
    bankOwnAccountType: new FormControl<number | null>(null),
  })

  constructor(
    private dialogRef:MatDialogRef<AddOrUpdateBankAccountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogService:DialogService,
    private _bankAccountAPIService:BankAccountsApiService,
    private settingsService:SettingsService,
    private _snackbarService:SnackbarService
  )
  {
    if (typeof data != 'undefined') {
      this.form.controls['_id'].setValue(this.data._id)
      this.form.controls['bank'].setValue(this.data.bank)
      this.form.controls['accountNumber'].setValue(this.data.accountNumber)
      this.form.controls['isVATAccount'].setValue(this.data.isVATAccount || false)
      
      // Dodatkowe pola KSeF
      if (this.data.swift) this.form.controls['swift'].setValue(this.data.swift)
      if (this.data.accountDescription) this.form.controls['accountDescription'].setValue(this.data.accountDescription)
      if (this.data.bankOwnAccountType) this.form.controls['bankOwnAccountType'].setValue(this.data.bankOwnAccountType)
    
      if(Utils.isDefined(data, "_id")) {
        this.mode = 'update'
      } 

      // Pokaż pola KSeF jeśli którekolwiek jest wypełnione
      this.showKsefFields = !!(this.data.swift || this.data.accountDescription || this.data.bankOwnAccountType)
    }
  }

  toggleKsefFields() {
    this.showKsefFields = !this.showKsefFields
  }

  create() {

    this._bankAccountAPIService.createBankAccount(this.form.value).pipe(take(1)).subscribe({
      next: (response:APIResponse) => {
        this.settingsService.refreshSettings()
        this.close()
      }
    })

  }

  update() {

    this._bankAccountAPIService.updateBankAccount(this.form.value).pipe(take(1)).subscribe({
      next: (response:APIResponse) => {
        this.settingsService.refreshSettings()
        this.close()
      }
    })
 
  }

  showDeleteConfirmation()
  {

    const id = this.form.controls._id?.value
    if(!id) return

    this.dialogService.confirmDialog({
      confirmText: "Potwierdzam usunięcie",
      cancelText: "Anuluj",
      message: `Czy na pewno chcesz usunąć numer konta: ${this.form.controls.accountNumber.value}?`,
      title: "Usuwanie numeru konta",
      type: 'danger'
    })
    .subscribe({
      next: (data)=> {
        if(data == true) {

          this._bankAccountAPIService.deleteBankAccount(id).pipe(take(1)).subscribe({
            next: (response:APIResponse) => {

              if(!response.success) return

              this.settingsService.refreshSettings()
              this._snackbarService.showSnackBar(response.message,'success')
              this.close()

            }
          })
        }
      }
    })
  }

  close() {
    this.dialogRef.close()
  }

}
